import React from 'react';
import { withTheme } from 'styled-components';
import {
  Box,
  Popup,
  useMedia,
  VerticalSpacing,
  Text,
} from '../../components/Boneyard';
import Markdown from '../../components/Markdown';
import PropTypes from 'prop-types';
import CLOSE_ICON_BLUE from '../../images/ic-close-white.svg';
import {
  withApplicationQuery,
  useTranslations,
} from '../../graphql/components/ApplicationQueryProvider';
import FORGOT_PASSWORD_TRANSLATIONS_QUERY from './taLoginPageTranslations.query.graphql.js';

const propTypes = {
  open: PropTypes.bool,
  openPopup: PropTypes.func,
};

const TAForgotPasswordPopUp = ({ open, openPopup }) => {
  const mq = useMedia();
  const { travelAgentLoginPage, common } = useTranslations();

  return (
    <Popup
      open={open}
      closeIconPath={CLOSE_ICON_BLUE}
      withDefaultPadding={false}
      onRequestClose={openPopup}
    >
      <Box
        w="600px"
        pt={mq.gte('lg') ? 6 : 4}
        pb={mq.gte('lg') ? 6 : 4}
        pr={6}
        pl={6}
        backgroundColor="#01579b"
        borderRadius={[10, 10, 0, 0]}
      >
        <Text size={25} weight={700} color="white">
          {common.forgotPasswordTitle}?
        </Text>
      </Box>

      <Box
        w="600px"
        pt={mq.gte('lg') ? 6 : 4}
        pb={mq.gte('lg') ? 6 : 4}
        pr={10}
        pl={10}
        borderRadius={[10, 10, 0, 0]}
      >
        <div style={{ textAlign: 'center' }}>
          <Text lh={1.5} size={16}>
            <Markdown
              source={travelAgentLoginPage.taForgotPasswordContentLabel}
            />
          </Text>
          <VerticalSpacing size={4} />
        </div>
      </Box>
    </Popup>
  );
};

TAForgotPasswordPopUp.propTypes = propTypes;

export default withApplicationQuery(
  FORGOT_PASSWORD_TRANSLATIONS_QUERY,
  withTheme(TAForgotPasswordPopUp)
);
